<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>系统管理</el-breadcrumb-item>
            <el-breadcrumb-item>易宝设置</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <!--卡片视图区-->
        <el-card>
            <!--搜索与添加区域-->
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-button type="primary" @click="addDialogVisible = true">添加易宝门店商户</el-button>
                    <!-- <el-input placeholder="请输入操作内容/操作人" clearable v-model="queryInfo.query" @clear="getList()" style="width: 300px;">
                        <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                    </el-input> -->
                    <!-- <el-select v-model="queryInfo.query1"  placeholder="请选择门店" @change="getList()"  style="margin-left:10px" clearable  filterable>
                        <el-option v-for="item in storelist" :key="item.id" :label="item.storename" :value="item.id"></el-option>
                    </el-select> -->
                </el-col>
            </el-row>
            <br>
            <!--搜索与添加区域-->
            <!--商品列表区域-->
            <el-table :data="list" :key="list.index" style="width: 100%" stripe size="middle" height="700">
                <el-table-column label="ID" type="index"  width="50"></el-table-column>
                <el-table-column label="门店名称" prop="storename"  width="300"></el-table-column>
                <el-table-column label="易宝编号" prop="merchantno" width="200"></el-table-column>
                <el-table-column label="系统商户编号" prop="merchantid" width="200">
                    <template slot-scope="scope">
                        {{ JSON.parse(scope.row.paramjson).merchantId }}
                    </template>
                </el-table-column>
                <el-table-column label="分帐商户编号" prop="ledgerno" width="200">
                    <template slot-scope="scope">
                        {{ JSON.parse(scope.row.paramjson).ledgerNo}}
                    </template>
                </el-table-column>
                <!-- <el-table-column label="接口私钥" prop="privatekey" width="300" show-overflow-tooltip></el-table-column>
                <el-table-column label="接口公钥" prop="publickey" width="300" show-overflow-tooltip></el-table-column> -->
                <el-table-column label="操作日期" prop="adddate" width="200"></el-table-column>
                <el-table-column label="操作">
                    <!--作用域插槽-->
                    <template slot-scope="scope">
                        <!-- {{scope.row}} -->
                        <el-button type="success" icon="el-icon-edit" size="mini" @click="EditYeePay(scope.row.id)"></el-button>
                        <!-- <el-button type="danger" icon="el-icon-delete" size="mini" @click="DelMerchant(scope.row.id)"></el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <!--商品列表区域-->
             <!--分页区域-->
             <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum" :page-sizes="[20,50,500,1000]"  :page-size="queryInfo.pagesize" 
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
            <!--分页区域-->
            <!--添加对话框-->
            <el-dialog title="添加门店商户" :visible.sync="addDialogVisible" width="40%" @close="addDialogClosed">
                <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="120px">
                    <el-form-item label="门店名称" prop="storeid">
                        <el-select  v-model="addForm.storeid"  placeholder="请选择门店" style="width:300px" filterable>
                            <el-option v-for="item in storelist" :key="item.id" :label="item.storename" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="易宝编号" prop="merchantno">
                        <el-input v-model="addForm.merchantno"  placeholder="请输入易宝编号" style="width:300px"></el-input>
                    </el-form-item>
                    <el-form-item label="系统商户编号" prop="merchantid">
                        <el-input v-model="addForm.merchantid" placeholder="请输入系统商户编号" style="width:300px"></el-input>
                    </el-form-item>
                    <el-form-item label="分帐商户编号" prop="ledgerno">
                        <el-input v-model="addForm.ledgerno" placeholder="请输入易宝分帐编号" style="width:300px"></el-input>
                    </el-form-item>
                    <el-form-item label="接口私钥" prop="privatekey">
                        <el-input v-model="addForm.privatekey" type="textarea" placeholder="请输入接口私钥"></el-input>
                    </el-form-item>
                    <el-form-item label="接口公钥" prop="publickey">
                        <el-input v-model="addForm.publickey" type="textarea" placeholder="请输入接口公钥"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="AddYeePay">确 定</el-button>
                </span>
            </el-dialog>
            <!--添加对话框-->
            <!--编辑对话框-->
            <el-dialog title="编辑门店商户" :visible.sync="editDialogVisible" width="40%" @close="addDialogClosed">
                <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="120px">
                    <el-form-item label="门店名称" prop="storeid">
                        <el-select  v-model="editForm.storeid"  placeholder="请选择门店" style="width:300px" filterable disabled>                            
                            <el-option v-for="item in storelist" :key="item.id" :label="item.storename" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="易宝编号" prop="merchantno">
                        <el-input v-model="editForm.merchantno"  placeholder="请输入易宝编号" style="width:300px"></el-input>
                    </el-form-item>
                    <el-form-item label="系统商户编号" prop="merchantid">
                        <el-input v-model="editForm.merchantid" placeholder="请输入系统商户编号" style="width:300px"></el-input>
                    </el-form-item>
                    <el-form-item label="分帐商户编号" prop="ledgerno">
                        <el-input v-model="editForm.ledgerno" placeholder="请输入易宝分帐编号" style="width:300px"></el-input>
                    </el-form-item>
                    <el-form-item label="接口私钥" prop="privatekey">
                        <el-input v-model="editForm.privatekey" type="textarea" placeholder="请输入接口私钥"></el-input>
                    </el-form-item>
                    <el-form-item label="接口公钥" prop="publickey">
                        <el-input v-model="editForm.publickey" type="textarea" placeholder="请输入接口公钥"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="editDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="EditYeepaySave(editForm.id)">确 定</el-button>
                </span>
            </el-dialog>
            <!--编辑对话框-->
        </el-card>
    </div>
</template>
<script>
export default {
    data() {
        return{
            queryInfo: {
                pagenum: 1,
                pagesize: 20
            },
            total:0,
            list: [],
            addDialogVisible:false,
            editDialogVisible:false,
            storelist:[],
            addForm:{
                 storeid:'',
                 merchantno:'',
                 merchantid:'',
                 ledgerno:'',
                 privatekey:'',
                 publickey:''
            },
            editForm:{
                 merchantno:'',
                 merchantid:'',
                 ledgerno:'',
                 privatekey:'',
                 publickey:''
            },
            //添加表单验证规则
            addFormRules:{
                storeid:[
                    { required: true, message: '请选择门店', trigger: 'blur' }
                ],
                merchantno:[
                    { required: true, message: '请输入易宝编号', trigger: 'blur' }
                ],
                merchantid:[
                    { required: true, message: '请输入系统商户编号', trigger: 'blur' }
                ],
                ledgerno:[
                    { required: true, message: '请输入易宝分帐编号', trigger: 'blur' }
                ],
                privatekey:[
                    { required: true, message: '请输入接口私钥', trigger: 'blur' }
                ],
                publickey:[
                    { required: true, message: '请输入接口公钥', trigger: 'blur' }
                ],
            },
            editFormRules:{
                merchantno:[
                    { required: true, message: '请输入易宝编号', trigger: 'blur' }
                ],
                merchantid:[
                    { required: true, message: '请输入系统商户编号', trigger: 'blur' }
                ],
                ledgerno:[
                    { required: true, message: '请输入易宝分帐编号', trigger: 'blur' }
                ],
                privatekey:[
                    { required: true, message: '请输入接口私钥', trigger: 'blur' }
                ],
                publickey:[
                    { required: true, message: '请输入接口公钥', trigger: 'blur' }
                ],
            },
        }
        
    },
    created() {
         this.getList()
         this.getStoreList()
    },
    mounted(){
        this.addForm.admin_token = window.sessionStorage.getItem('admin_token') 
    },
    methods:{
        async getStoreList(){
            const { data: res } = await this.$http.get('store/')
            this.storelist = res.data
        },
        async getList() {
            const { data:res } = await this.$http.get('yeepaylist/',{ params: this.queryInfo })
            if(res.status == 1){
                this.total = res.data.totalCount;
                this.list = res.data.list.map(v => {
                //在返回的数据里增加一条数据
                // console.log(v.fields)
                return v.fields
                })
            }
            for (let index = 0; index < res.data.list.length; index++) {
                this.list[index].id= res.data.list[index].pk;
            }
        },
        handleSizeChange(newSize){
          // console.log(newSize)
           this.queryInfo.pagesize = newSize
           this.getList()
       },
       handleCurrentChange(newPage){
          // console.log(newPage)
           this.queryInfo.pagenum = newPage
           this.getList()
       },
       addDialogClosed(){
            this.$refs.addFormRef.resetFields()
       },
       editDialogClosed(){
            this.$refs.editFormRef.resetFields()
       },
       AddYeePay(){
        this.$refs.addFormRef.validate( async valid=>{
            if (!valid) return
            this.addForm.paramjson = JSON.stringify({"merchantNo":this.addForm.merchantno,"merchantId":this.addForm.merchantid,
            "ledgerNo":this.addForm.ledgerno,"rSA_PRIVATE_KEY":this.addForm.privatekey,"rSA_PUBLIC_KEY":this.addForm.publickey})
            const { data:res } = await this.$http.post('yeepayadd/',this.addForm)
            if(res.status===0)
            {
                this.$message.success('添加门店商户成功！')
                this.addDialogVisible = false
                this.getList()
            }
            if(res.status == 1){
                this.$message.error('此门店商户已存在！')
            }
        })
       },
       async EditYeePay(id){
           const { data: res } = await this.$http.get('yeepayinfo/'+id)
            this.editDialogVisible = true
            // this.editForm = res;
            let paramjson = JSON.parse(res.paramjson)
            this.editForm.id = res.id
            this.editForm.storeid = res.storeid
            this.editForm.merchantid = paramjson.merchantId
            this.editForm.merchantno = paramjson.merchantNo
            this.editForm.ledgerno = paramjson.ledgerNo
            this.editForm.privatekey = paramjson.rSA_PRIVATE_KEY
            this.editForm.publickey = paramjson.rSA_PUBLIC_KEY
            
            this.editForm.admin_token =window.sessionStorage.getItem('admin_token')
       },
       EditYeepaySave(id){
           this.$refs.editFormRef.validate(async valid => {
                if (!valid) return
                this.editForm.paramjson = JSON.stringify({"merchantNo":this.editForm.merchantno,"merchantId":this.editForm.merchantid,
               "ledgerNo":this.editForm.ledgerno,"rSA_PRIVATE_KEY":this.editForm.privatekey,"rSA_PUBLIC_KEY":this.editForm.publickey})
                const { data: res } = await this.$http.post('yeepayedit/' + id,this.editForm)
                if (res.status === 0) {
                    this.$message.success('客服修改成功')
                    this.editDialogVisible = false
                    this.getList()
                }
            })
       },
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
    }
    .el-breadcrumb{
        width: 100%;
    }
    el-table__row>td {
    border: none;
    }

    .el-table::before {
        height: 0px;
    }

</style>